import { render } from "./SetAdminRoundTimes.vue?vue&type=template&id=52492fde"
import script from "./SetAdminRoundTimes.vue?vue&type=script&lang=js"
export * from "./SetAdminRoundTimes.vue?vue&type=script&lang=js"

import "./SetAdminRoundTimes.vue?vue&type=style&index=0&id=52492fde&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__